import { render, staticRenderFns } from "./SideMenuTemplate.vue?vue&type=template&id=670688f8"
var script = {}
import style0 from "./SideMenuTemplate.vue?vue&type=style&index=0&id=670688f8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670688f8')) {
      api.createRecord('670688f8', component.options)
    } else {
      api.reload('670688f8', component.options)
    }
    module.hot.accept("./SideMenuTemplate.vue?vue&type=template&id=670688f8", function () {
      api.rerender('670688f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/templates/SideMenuTemplate.vue"
export default component.exports